export default __webpack_public_path__ + "static/media/Record_Pause.d2c02b6c.svg";